import { routes } from 'router';

export const travelPurchaseSteps = [
  {
    slug: 'selection',
    path: routes.travelPurchase.children.selection.path,
    order: 0,
    completed: false,
    valid: false,
    current: true
  },
  {
    slug: 'configuration',
    path: routes.travelPurchase.children.configuration.path,
    order: 1,
    completed: false,
    valid: false,
    current: false
  },
  {
    slug: 'insurance',
    path: routes.travelPurchase.children.insurance.path,
    order: 2,
    completed: false,
    valid: false,
    current: false
  },
  {
    slug: 'informations',
    path: routes.travelPurchase.children.informations.path,
    order: 3,
    completed: false,
    valid: false,
    current: false
  },
  {
    slug: 'validation',
    path: routes.travelPurchase.children.validation.path,
    order: 4,
    completed: false,
    valid: false,
    current: false
  },
  {
    slug: 'payment',
    path: routes.travelPurchase.children.payment.path,
    order: 5,
    completed: false,
    valid: false,
    current: false
  }
];

export const travelFormDefaultValues = {
  selection: {
    from: '',
    duration: '',
    monthYear: '',
    /*
      Informations about categories of passengers (adult, child etc...), min age, max age and quantity for each category
    */
    passengers: [],
    /**
     * Travel selected line in the TravelSelectionTable
     * This value is required in order to continue to step 2 (configuration)
     * @type {Object} - { departureDate: string, returnDate: string }
     */
    selectedTravel: null
  },
  configuration: {
    /* Informations about each participant (name, firstname, serialNumber etc...) */
    participants: [],
    lodging: null
  },
  insurance: null,
  shipping: {
    civility: '',
    firstname: '',
    lastname: '',
    street: '',
    complement1: '',
    complement2: '',
    postalCode: '',
    city: ''
  },
  validation: {
    subventionChoice: 'withoutSubvention',
    subventionAmount: null,
    subventionValid: false,
    depositChoice: null,
    paymentMethod: null,
    newsletter: false,
    salesTerms: false,
    specificSalesTerms: false
  }
};
